import axios from "axios";

const API_URL = `https://paymeapi.ligglo.co.ke/api/AuthenticateJWT/`;
//const API_URL = `https://localhost:44321/api/AuthenticateJWT/`;
const register = (username, email, password, phoneNumber) => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.post(
    API_URL + "register-admin",
    {
      username,
      email,
      password,
      phoneNumber,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const registerClientUser = (username, email, password, phoneNumber) => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.post(
    API_URL + "register",
    {
      username,
      email,
      password,
      phoneNumber,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const login = (username, password) => {
  return axios
    .post(API_URL + "loginweb", {
      username,
      password,
    })
    .then((response) => {
      if (response.data.user) {
        localStorage.setItem("jwt", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const logout = () => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  localStorage.removeItem("jwt");

  return axios.post(API_URL + "logoutweb").then(
    (response) => {
      return response.data;
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("jwt"));
};
const changePassword = (oldPassword, newPassword) => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.post(
    API_URL + "changepassword",
    {
      oldPassword,
      newPassword,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const resetPassword = (userId, password) => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.post(
    API_URL + "resetpassword",
    {
      userId,
      password,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const updatePhoneNumber = (userId, phoneNumber) => {
  var user = JSON.parse(localStorage.getItem("jwt"));
  var token = user && user.token;
  return axios.post(
    API_URL + "updatephone",
    {
      userId,
      phoneNumber,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
  changePassword,
  resetPassword,
  registerClientUser,
  updatePhoneNumber,
};

export default AuthService;
